(function () {
  if (window.NasheCollectionScrollRestore) return;

  var storageKey = 'nashe:collection-scroll';
  var maxAge = 30 * 60 * 1000;
  var restoreStarted = false;

  window.NasheCollectionScrollRestore = true;

  function currentUrl() {
    return window.location.href.split('#')[0];
  }

  function readState() {
    try {
      return JSON.parse(sessionStorage.getItem(storageKey) || 'null');
    } catch (error) {
      return null;
    }
  }

  function isFreshState(state) {
    return state && state.url === currentUrl() && state.time && Date.now() - state.time <= maxAge;
  }

  function isBackForwardNavigation() {
    var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    return nav && nav.type === 'back_forward';
  }

  try {
    if ('scrollRestoration' in history) {
      history.scrollRestoration = isFreshState(readState()) ? 'manual' : 'auto';
    }
  } catch (error) {
    return;
  }

  function productPath(productUrl) {
    try {
      return new URL(productUrl, window.location.origin).pathname;
    } catch (error) {
      return '';
    }
  }

  function collectionContext(target) {
    var item = target && target.closest('.nashe-product-item, .product-card, .grid__item');
    var grid = item && item.closest('[data-nashe-grid], [data-summer-grid], [data-sale-grid], #product-grid, .product-grid');
    var items = grid ? Array.prototype.slice.call(grid.querySelectorAll('.nashe-product-item, .product-card, .grid__item')) : [];
    var index = item ? items.indexOf(item) : -1;
    return {
      productIndex: index,
      loadedCount: items.length,
    };
  }

  function writeState(productUrl, target) {
    var context = collectionContext(target);
    try {
      sessionStorage.setItem(
        storageKey,
        JSON.stringify({
          url: currentUrl(),
          y: Math.max(0, window.scrollY || window.pageYOffset || 0),
          productUrl: productUrl,
          productPath: productPath(productUrl),
          productIndex: context.productIndex,
          loadedCount: context.loadedCount,
          time: Date.now(),
        })
      );
    } catch (error) {
      return;
    }
  }

  function clearState() {
    try {
      sessionStorage.removeItem(storageKey);
    } catch (error) {
      return;
    }
  }

  function productUrlFromClick(target) {
    if (!target) return null;
    if (target.closest('form, button, input, select, textarea, [data-add-to-cart]')) return null;

    var link = target.closest('a[href]');
    if (!link) {
      var card = target.closest('.product-card, .card-wrapper, .product-card-wrapper, .grid__item');
      if (card) link = card.querySelector('a[href]');
    }
    if (!link) return null;

    var url;
    try {
      url = new URL(link.getAttribute('href'), window.location.origin);
    } catch (error) {
      return null;
    }

    if (url.origin !== window.location.origin) return null;
    if (url.pathname.indexOf('/products/') === -1) return null;
    return url.href;
  }

  function maxScrollY() {
    return Math.max(
      0,
      document.documentElement.scrollHeight - window.innerHeight,
      document.body ? document.body.scrollHeight - window.innerHeight : 0
    );
  }

  function scrollToSaved(y) {
    window.scrollTo(0, Math.min(Math.max(0, y), maxScrollY()));
  }

  function findTarget(state) {
    if (!state || !state.productPath) return null;
    var links = document.querySelectorAll('a[href*="/products/"]');
    for (var i = 0; i < links.length; i += 1) {
      var path = '';
      try {
        path = new URL(links[i].getAttribute('href'), window.location.origin).pathname;
      } catch (error) {
        path = '';
      }
      if (path === state.productPath) {
        return links[i].closest('.nashe-product-item, .product-card, .grid__item') || links[i];
      }
    }
    return null;
  }

  function getLoaders() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-nashe-grid], [data-summer-grid], [data-sale-grid]'))
      .map(function (grid) {
        var section = grid.closest('.nashe-collection-hub, [data-summer-section], [data-sale-section]');
        return section && section.__nasheLoadMoreController ? section.__nasheLoadMoreController : null;
      })
      .filter(Boolean);
  }

  function currentLoadedCount() {
    var max = 0;
    document.querySelectorAll('[data-nashe-grid], [data-summer-grid], [data-sale-grid], #product-grid').forEach(function (grid) {
      var count = grid.querySelectorAll('.nashe-product-item, .product-card, .grid__item').length;
      if (count > max) max = count;
    });
    return max;
  }

  function hydrateUntilReady(state) {
    var targetCount = Number(state.loadedCount) || 0;
    var attempts = 0;
    var maxAttempts = 12;

    function step() {
      if (findTarget(state)) return Promise.resolve();
      if (targetCount && currentLoadedCount() >= targetCount) return Promise.resolve();

      var loaders = getLoaders().filter(function (loader) {
        return loader && loader.getNextUrl && loader.getNextUrl();
      });
      if (!loaders.length || attempts >= maxAttempts) return Promise.resolve();

      attempts += 1;
      return loaders[0].loadOnce({ silent: true }).then(function () {
        return step();
      }).catch(function () {
        return undefined;
      });
    }

    return step();
  }

  function restore(state, options) {
    options = options || {};
    if (restoreStarted) return;
    if (!state || state.url !== currentUrl()) return;
    if (!state.time || Date.now() - state.time > maxAge) {
      clearState();
      return;
    }
    if (!options.force && !isBackForwardNavigation()) return;

    restoreStarted = true;
    var targetY = Number(state.y) || 0;

    hydrateUntilReady(state).then(function () {
      var target = findTarget(state);
      if (target) {
        targetY = Math.max(0, target.getBoundingClientRect().top + window.pageYOffset - 110);
      }

      window.requestAnimationFrame(function () {
        scrollToSaved(targetY);
        window.setTimeout(clearState, 120);
      });
    });
  }

  function cancelRestore() {
    restoreStarted = true;
  }

  document.addEventListener(
    'click',
    function (event) {
      var productUrl = productUrlFromClick(event.target);
      if (productUrl) writeState(productUrl, event.target);
    },
    true
  );

  ['wheel', 'touchstart', 'keydown'].forEach(function (eventName) {
    window.addEventListener(eventName, cancelRestore, { passive: true, once: true });
  });

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      clearState();
      return;
    }
    restore(readState());
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      restore(readState());
    });
  } else {
    restore(readState());
  }
})();
